import curdGenerator from "./curdGenerator";

export const accounts = [
  {
    module: "Accounts",
    children: [
      {
        module: "Transactions",
        children: [
          curdGenerator("Voucher"),
          curdGenerator("Bank Reconciliation"),
          curdGenerator("OPD IPD Diagnostics Account Posting")
        ]
      },
      {
        module: "Display",
        children: [
          { module: "Balance Sheet", permission: "balancesheet", children: [] },
          {
            module: "Profit And Loss Account",
            permission: "profitandlossaccount",
            children: []
          },
          {
            module: "Trial Balance Group",
            permission: "trialbalancegroup",
            children: []
          },
          {
            module: "Trial Balance Ledger",
            permission: "trialbalanceledger",
            children: []
          }
        ]
      },
      {
        module: "Reports",
        children: [
          { module: "Daily Book", permission: "dailybook", children: [] },
          {
            module: "Ledger",
            permission: "ledger",
            children: []
          },
          {
            module: "Interest Ledger",
            permission: "interestledger",
            children: []
          },
          { module: "Cash Book", permission: "cashbook", children: [] },
          {
            module: "Cash Book Consolidated",
            permission: "cashbookconsolidated",
            children: []
          },
          {
            module: "Bank Book",
            permission: "bankbook",
            children: []
          },
          { module: "Jurnal Book", permission: "jurnalbook", children: [] },
          {
            module: "Annexure",
            permission: "annexure",
            children: []
          },
          {
            module: "Bank Register",
            permission: "bankregister",
            children: []
          },
          {
            module: "Ageing Analysis For Debtors",
            permission: "ageinganalysisfordebtors",
            children: []
          },
          {
            module: "Ageing Analysis For Creditors",
            permission: "ageinganalysisforcreditors",
            children: []
          },
          {
            module: "Cheque Cleared Register",
            permission: "chequeclearedregister",
            children: []
          },
          {
            module: "Cheque Not Cleared Register",
            permission: "chequenotclearedregister",
            children: []
          },
          {
            module: "Outstanding Report For Debtors",
            permission: "outstandingreportfordebtors",
            children: []
          },
          {
            module: "Outstanding Report For Creditors",
            permission: "outstandingreportforcreditors",
            children: []
          },
          {
            module: "Daily Transaction Summary",
            permission: "dailytransactionsummary",
            children: []
          },
          {
            module: "Detailed Trial Ledger",
            permission: "detailedtrialledger",
            children: []
          },
          {
            module: "Account Check List",
            permission: "accountchecklist",
            children: []
          },
          {
            module: "Bill Wise Outstanding For Debtors",
            permission: "billwiseoutstandingfordebtors",
            children: []
          },
          {
            module: "User Wise Edit Report",
            permission: "userwiseeditreport",
            children: []
          },
          {
            module: "Details Of Expenses Revenue Month Wise",
            permission: "detailsofexpensesrevenuemonthwise",
            children: []
          }
        ]
      },
      {
        module: "Utility",
        children: [
          {
            module: "Parameter Setting",
            permission: "parametersetting",
            children: []
          },
          {
            module: "Opening Balance Transfer",
            permission: "openingbalancetransfer",
            children: []
          }
        ]
      }
    ]
  }
];
